module.exports = __webpack_public_path__ + "static/media/magnet-black.8dd726f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/magnet-black.svg
// module id = 527
// module chunks = 0